import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import ImageBlockPrototype from '/react4xp/components/prototype/ImageBlock'
import type { ImageBlockImage } from '/react4xp/components/prototype/ImageBlock/types'

type ImageBlockPartImage = {
	src: string
	alt?: string
	caption?: string
}

type ImageBlockPartData = {
	images?: ImageBlockPartImage[]
}

export const ImageBlock = ({ data }: ComponentProps<PartData>) => {
	const { images = [] } = (data || {}) as ImageBlockPartData

	// `isPart` makes the prototype wrap itself in `container my-16` (see the
	// prototype's /components/image-block preview); the macro renders bare inside
	// the rich text that already sits in a container.
	return (
		<ImageBlockPrototype
			images={images.map<ImageBlockImage>((image) => ({
				src: image.src,
				alt: image.alt || '',
				caption: image.caption,
			}))}
			isPart
		/>
	)
}
